// src/pages/CrearUsuario.js
import React, { useState } from 'react';
import { crearUsuario } from '../services/usuarioService';

const CrearUsuario = ({ token }) => {
  const [form, setForm] = useState({
    nombre_usuario: '',
    password: '',
    rol: 'usuario',
    telefono: ''
  });
  const [mensaje, setMensaje] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resultado = await crearUsuario(form, token);
    setMensaje(resultado.mensaje || 'Usuario creado correctamente');
    setForm({ nombre_usuario: '', password: '', rol: 'usuario', telefono: '' });
  };

  return (
    <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
      <h2 className="text-xl font-bold mb-4">Registrar Usuario</h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-3">
        <input
          name="nombre_usuario"
          value={form.nombre_usuario}
          onChange={handleChange}
          placeholder="Nombre de usuario"
          className="p-2 border"
          required
        />
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          placeholder="Contraseña"
          className="p-2 border"
          required
        />
        <input
          name="telefono"
          value={form.telefono}
          onChange={handleChange}
          placeholder="Teléfono"
          className="p-2 border"
          required
          pattern="^[+0-9\s-]{9,20}$"
          title="Ingrese un número válido"
        />
        <select
          name="rol"
          value={form.rol}
          onChange={handleChange}
          className="p-2 border"
        >
          <option value="usuario">Usuario</option>
          <option value="admin">Administrador</option>
        </select>
        <button type="submit" className="bg-blue-600 text-white py-2 rounded">
          Crear usuario
        </button>
      </form>
      {mensaje && <p className="mt-4 text-green-600 font-semibold">{mensaje}</p>}
    </div>
  );
};

export default CrearUsuario;
